import { Component, OnInit, OnChanges, Input, AfterViewInit, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';

export class DualListBoxItem {
  private _data: Object;
  private _selected: boolean;
  private _visible: boolean;

  constructor(data?: Object, selected?: boolean, visible?: boolean) {
    this._data = data;
    this._selected = selected;
    this._visible = visible;
  }
  public get Data() {
    return this._data;
  }
  public get Selected() {
    return this._selected;
  }
  public get Visible() {
    return this._visible;
  }
  public set Data(data) {
    this._data = data;
  }
  public set Selected(selected) {
    this._selected = selected;
  }
  public set Visible(visible) {
    this._visible = visible;
  }
}

@Component({
  selector: 'app-dual-list-box',
  templateUrl: './dual-list-box.component.html',
  styleUrls: ['./dual-list-box.component.scss']
})
export class DualListBoxComponent implements OnInit, OnChanges, AfterViewInit {

  filterInputKey;
  filterOutputKey;
  private input: Map<any, DualListBoxItem>;
  private output: Map<any,  DualListBoxItem>;
  @Output() addEvent = new EventEmitter<any>();
  @Output() removeEvent = new EventEmitter<any>();
  @Output() outputEvent = new EventEmitter<any>();
  @Input() inputId;
  @Input() outputId;
  @Input() title;
  @Input() display;
  @Input() displaySeparator;
  @Input() showFilterInput;
  @Input() showFilterOutput;
  @Input() filterInputKeys;
  @Input() filterOutputKeys;
  @Input() public set inData(data) {
            if (data) {
              let id = 'id';
              if (this.inputId) {
                id = this.inputId;
              }
              this.input.clear();
              for (const i of data) {
                this.input.set(eval('i.' + id), new DualListBoxItem(i, false, true));
              }
              if (data.length === 0) {
                this.input.clear();
                this.output.clear();
              }
            }
          }
  @Input()  public set outData(data) {
              if (data) {
                let id = 'id';
                if (this.outputId) {
                  id = this.outputId;
                }
                this.output.clear();
                for (const o of data) {
                  this.output.set(eval('o.' + id), new DualListBoxItem(o, false, true));
                }
                if (data.length === 0) {
                  this.output.clear();
                }
              }
            }

  constructor(private cd: ChangeDetectorRef) {
    this.input = new Map<any, DualListBoxItem>();
    this.output = new Map<any, DualListBoxItem>();
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.init();
  }

  ngOnChanges() {
    this.init();
  }
  public init() {
    if (this.input && this.output) {
      for (const o of this.output) {
        this.input.delete(o[0]);
        this.cd.detectChanges();
      }
    }
  }

  public get(map) {
    return Array.from(eval('this.' + map).entries());
  }

  public toggle(map, itemkey) {
    eval('this.' + map).get(itemkey).Selected = !eval('this.' + map).get(itemkey).Selected;
  }

  public add() {
    const addedItems = new Array<any>();
    for (const item of this.input) {
      if (item[1].Selected) {
        item[1].Selected = false;
        this.output.set(item[0], item[1]);
        addedItems.push(item[1].Data);
        this.input.delete(item[0]);
      }
    }
    this.addEvent.emit({ addedItems });
    this.outputEvent.emit(this.output);
  }

  public remove() {
    const removedItems = new Array<any>();
    for (const item of this.output) {
      if (item[1].Selected) {
        item[1].Selected = false;
        this.input.set(item[0], item[1]);
        removedItems.push(item[1].Data);
        this.output.delete(item[0]);
      }
    }
    this.removeEvent.emit({ removedItems });
    this.outputEvent.emit(this.output);
  }

  public all(map) {
    for (const item of eval('this.' + map).values()) {
      item.Selected = true;
    }
  }

  public none(map) {
    for (const item of eval('this.' + map).values()) {
      item.Selected = false;
    }
  }

  public trackByIndex(index, item) {
    return index;
  }

  public getCompleteTitle(item, display) {
    let completeTitle = '';
    if (item && display && this.displaySeparator) {
      display.forEach((d, i) => {
        completeTitle += item.Data[d];
        if (i < (display.length - 1)) {
          completeTitle += this.displaySeparator;
        }
      } );
      return completeTitle;
    }
    return completeTitle;
  }

  public filterInput(items, e) {
    const regExp1 = '[a-zA-Z0-9?!"·$%&/()=?¿|@#~€¬^*¨Ç;:_]*';
    const regExp2 = '[a-zA-Z0-9?!"·$%&/()=?¿|@#~€¬^*¨Ç;:_]*';
    this.filterInputKey = e.target.value;
    const regExp = new RegExp(regExp1 + this.filterInputKey + regExp2, 'i');
    if (!this.filterInputKey) {
      this.filterInputKey = e.target.value;
    }
    if (items) {
      items.forEach(i => {
        for (const arg of this.filterInputKeys) {
          if (regExp.test(i[1].Data[arg])) {
            i[1].Visible = true;
            break;
          } else {
            i[1].Visible = false;
          }
        }
      });
    }
  }

  public filterOutput(items, e) {
    const regExp1 = '[a-zA-Z0-9?!"·$%&/()=?¿|@#~€¬^*¨Ç;:_]*';
    const regExp2 = '[a-zA-Z0-9?!"·$%&/()=?¿|@#~€¬^*¨Ç;:_]*';
    this.filterOutputKey = e.target.value;
    const regExp = new RegExp(regExp1 + this.filterOutputKey + regExp2, 'i');
    if (!this.filterOutputKey) {
      this.filterOutputKey = e.target.value;
    }
    if (items) {
      items.forEach(i => {
        for (const arg of this.filterOutputKeys) {
          if (regExp.test(i[1].Data[arg])) {
            i[1].Visible = true;
            break;
          } else {
            i[1].Visible = false;
          }
        }
      });
    }
  }

}
